import { Component, Vue } from 'vue-property-decorator'

import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import AppRadio from '@/components/AppRadio.vue'
import { MemberModel } from '@/interfaces/member'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime'
import { deleteMember } from './gql'
import { TypedGqlError } from '@/interfaces/error'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppRadio,
    AppLightModal
  }
})
export default class MemberDialog extends Vue {
  targetMember: MemberModel | null = null

  utcDateTimeToLocal = utcDateTimeToLocal
  utcDateTimeToDate = utcDateTimeToDate

  deleteDialog = {
    show: false,
    title: '删除会员',
    text: ''
  }

  deleteHandler (item: any) {
    this.targetMember = item
    this.deleteDialog.text = `是否确定删除会员 “${item.nickname}” ?`
    this.deleteDialog.show = true
  }

  // delete request
  async deleteRequest () {
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteMember,
        variables: {
          memberId: Number(this.targetMember?.id)
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功!',
          type: SnackType.Info
        })
      }
      this.deleteDialog.show = false
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
